import { createContext } from 'react';

export interface ElementLocationProps {
  /** The structural region of the page this context scope belongs to. */
  elementLocation: 'Page' | 'Header' | 'Footer' | 'SideNavigation' | string | undefined;
}

export const ElementLocation = createContext<ElementLocationProps>({
  elementLocation: undefined,
});
